export function extractFileInfo(filename) {
    const parts = filename.split("/");
    const file = parts[parts.length - 1]; // Get last part of path
    const fileWithoutExt = file.replace(".flac", "");

    // Check if the filename contains "_"
    if (!fileWithoutExt.includes("_")) {
      console.warn("Filename does not contain expected '_' separators:", filename);
      return { datetime: null, sampleRate: null, duration: 3 }; // Return safe defaults
    }
  
    const [datetime, sampleRate, duration] = fileWithoutExt.split("_");
  
    return { 
      fileUnixTime: datetime || null, 
      sampleRate: Number(sampleRate) || null, 
      duration: Number(duration) || null 
    };
  }
  